<template>
  <div id="Vlt-sidenav" class="Vlt-sidenav Vlt-sidenav--dark">
    <!-- Fixed blocks (optional) -->
    <div class="Vlt-sidenav__block Vlt-sidenav__block--logo Vlt-M-plus">

        <vlt-icon class="Vlt-white Vlt-margin--bottom1" icon="app"/>
&nbsp; &nbsp;
      <span style="font-size: 1.8em" class="Vlt-white Vlt-margin--bottom1" v-if="isAdmin">{{$t('message.dashboard.admin_dashboard')}}</span>
      <span style="font-size: 1.8em" class="Vlt-white Vlt-margin--bottom1" v-else>{{$t('message.dashboard.dashboard')}}</span>

      <!--      <a href="/#/" class="Vlt-sidenav__logo">-->
<!--        <img style="height: 24px;" src="../assets/logos/vonage-logo&#45;&#45;white.svg" alt="logo">-->
<!--      </a>-->
    </div>
    <!-- Top tabs (optional) -->
    <div class="Vlt-sidenav__scroll">
      <!-- Menu -->
      <vlt-sidemenu>
        <li>
          <vlt-sidemenu-link :to="'/dashboard/manage'" icon="phone-garland" small
                             :label="$t('message.dashboard.adminDashboard.manage_calls')">
          </vlt-sidemenu-link>
        </li>
        <li>
          <vlt-sidemenu-link :to="'/dashboard/users'" icon="user" small
                             :label="$t('message.dashboard.adminDashboard.manage_users')">
          </vlt-sidemenu-link>
        </li>
<!--        <li>-->
<!--          <vlt-sidemenu-link :to="'/dashboard/history'" icon="history" small-->
<!--                             :label="$t('message.dashboard.adminDashboard.history')">-->
<!--          </vlt-sidemenu-link>-->
<!--        </li>-->
      </vlt-sidemenu>
    </div>
    <!-- Bottom tabs (optional) -->
    <!-- Fixed blocks (optional) -->
    <div class="Vlt-sidenav__block Vlt-sidenav__block--link Vlt-sidenav__block--border-top ">
      <ul class="Vlt-sidemenu">
        <li>
          <a href="" @click.prevent="logout"
             class="Vlt-sidemenu__link  Vlt-logout">
            <vlt-icon icon="exit" small />
            <span class="Vlt-sidemenu__label">{{$t('message.btnLogout')}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VltIcon, VltSidemenu, VltSidemenuLink } from '@vonagevolta/vue';

export default {
  name: 'Sidebar',
  components: {
    VltIcon, VltSidemenu, VltSidemenuLink,
  },

  methods: {
//    logout() {
//      this.$emit('logout');
//    },
  },

  props: {
    logout: {
      type: Function,
      required: true,
    },
  },
  computed: {
    // isAdmin() {
    //   return this.$auth.isAdmin;
    // },
    ...mapGetters({
        isLoggedIn: 'isLoggedIn',
        isAdmin: 'isAdmin',
    }),
  },
};
</script>

<style scoped>
  ul.Vlt-sidemenu {
    background-image: none;
  }
  .Vlt-sidenav__block {
    padding: 10px 6px;
    margin-top: 14px;
  }
</style>
